module.exports = __webpack_public_path__ + "static/media/activesavesticon.86cb8a2c.svg";